module.exports = __webpack_public_path__ + "img/edit-disclaimer-img.346f82d1.png";